module.exports = __webpack_public_path__ + "static/media/foster4.f1279724.jpg";